<template>
  <PanelCard v-if="visible" :title="I18n.t('user.panel.pulse_access_title')">
    <AccessList
      testid="user-panel-customer-roles"
      icon="pulse"
      :label="I18n.t('user.panel.pulse_access_count', { count: portals.count })"
      :empty-label="I18n.t('user.panel.no_pulse_added')"
      :find-placeholder="I18n.t('user.panel.search_assigned_pulse_portals')"
      :items="portals.items"
      :paging="portals.paging"
      :adding="{
        label: I18n.t('user.panel.add_pulse_portal'),
        placeholder: I18n.t('user.panel.search_pulse_portals'),
        addedIds: store.addedRoleCompanyIds,
        search: searchPulsePortals,
      }"
      @add="store.addRole('customerRoles', $event)"
      @remove="store.removeRole('customerRoles', $event)"
      @search="portals.search"
      @load-more="portals.loadMore"
    />
  </PanelCard>
</template>

<script setup lang="ts">
import type { AutocompleteOption } from '@app/application/user-management/types'

import { computed } from 'vue'

import { roleKinds } from '@app/application/user-management/types'
import { searchCompanies } from '@app/application/user-management/api/user-panel'
import { roleItems } from '@app/application/user-management/utils/access-lists'
import { useUserPanelStore } from '@app/application/user-management/stores/user-panel'
import useAccessList from '@app/application/user-management/composables/use-access-list'
import useI18n from '@app/shared/vue/composables/use-I18n'
import AccessList from '@app/application/user-management/components/user-panel/access-list.vue'
import PanelCard from '@app/application/user-management/components/panel-card.vue'

defineOptions({ name: 'PulseAccessSection' })

const I18n = useI18n()
const store = useUserPanelStore()

const visible = computed(() => store.shownLists.includes('customerRoles'))

const portals = useAccessList('customerRoles', roleItems)

const searchPulsePortals = (
  query: string,
  signal: AbortSignal,
  limit: number
): Promise<AutocompleteOption[] | null> =>
  searchCompanies(store.openUserId, query, roleKinds.CUSTOMER, signal, limit)
</script>
